<div class="settings" [hidden]="!visible">

  <div class="item">
    <app-description-toggle></app-description-toggle>
  </div>

  <div class="item">
    <app-font-size></app-font-size>
  </div>
  <div class="item mode-toggle item-block">
    <div class="item-header">
      <mat-icon
        class="icon-default mode-icon menu-icon"
        fontSet="material-icons-outlined"
        aria-hidden="true"
        >support_agent
      </mat-icon>

      <span>Support-Modus</span>
      <mat-slide-toggle
        [formControl]="supportModeControl"
        class="eFormsSlider"
        aria-label="Schalter für den Support-Modus. Bitte aktivieren Sie diesen Modus, wenn Sie vom Support dazu aufgefordert werden.">
      </mat-slide-toggle>
    </div>
    <div class="item-body">
      <p *ngIf="!isRS">Bitte aktivieren Sie diesen Modus, wenn Sie vom Support dazu aufgefordert werden.</p>
      <p *ngIf="isRS">Dieser Modus dient der zusätzlichen Anzeige von technischen Informationen wie eForms-Business-Terms, Codewerten und Erläuterungen zu aktuell nicht vorgesehenen Feldern.</p>
    </div>
  </div>

  <div *ngIf="superEditModeAvailable" class="item mode-toggle item-block">
    <div class="item-header">
      <mat-icon
        class="icon-default mode-icon menu-icon"
        fontSet="material-icons-outlined"
        aria-hidden="true"
      >lock_open
      </mat-icon>
      <span>Uneingeschränkter Modus</span>
      <mat-slide-toggle [formControl]="superEditModeControl" class="eFormsSlider">
      </mat-slide-toggle>
    </div>
    <div class="item-body">
      <p>
        Bitte aktivieren Sie diese Option ausschließlich, wenn Sie vom Support dazu aufgefordert
        werden. Dieser Modus erlaubt u.a. das Bearbeiten von nicht bearbeitbaren Feldern und das
        Absenden des Formulars mit vorhandenen Fehlermeldungen.
      </p>
      <p class="warn">
        Die Korrektheit der Formularinhalte ist damit nicht mehr gewährleistet und es sind weitere
        Systemfehler zu erwarten
      </p>
    </div>
  </div>

  <div *ngIf="!isRS" class="item mode-toggle">
    <mat-icon class="icon-default mode-icon menu-icon" aria-hidden="true">block</mat-icon>
    <span>Unsichtbare Felder anzeigen</span>
    <mat-slide-toggle
      [formControl]="hiddenFieldsModeControl"
      class="eFormsSlider"
      aria-label="Verbotene Felder anzeigen/ausblenden">
    </mat-slide-toggle>
  </div>

  <div *ngIf="devModeAvailable" class="item mode-toggle">
    <mat-icon class="icon-default mode-icon menu-icon" aria-hidden="true">bug_report</mat-icon>
    <span>Entwickler-Modus</span>
    <mat-slide-toggle
      [formControl]="devModeControl"
      class="eFormsSlider"
      aria-label="Schalter für den Entwicklungsmodus">
    </mat-slide-toggle>
  </div>

  <button class="eForms-button eForms-button--primary" (click)="close.emit(true)">Schließen</button>
</div>
